import { Service } from '../../types';

/**
 * Find potential duplicate services based on name similarity.
 * Returns a Map of serviceId -> array of similar serviceIds.
 */
export function findDuplicates(services: Service[]): Map<string, string[]> {
  const duplicateMap = new Map<string, string[]>();

  for (let i = 0; i < services.length; i++) {
    for (let j = i + 1; j < services.length; j++) {
      const a = services[i];
      const b = services[j];

      const nameA = a.name.toLowerCase().trim();
      const nameB = b.name.toLowerCase().trim();

      // Check: exact match, substring match, or shared prefix >= 4 chars
      const isSimilar =
        nameA === nameB ||
        nameA.includes(nameB) || nameB.includes(nameA) ||
        (nameA.length >= 4 && nameB.length >= 4 &&
         nameA.substring(0, 4) === nameB.substring(0, 4));

      if (isSimilar) {
        // Add bidirectional mapping
        if (!duplicateMap.has(a.id)) duplicateMap.set(a.id, []);
        if (!duplicateMap.has(b.id)) duplicateMap.set(b.id, []);
        duplicateMap.get(a.id)!.push(b.id);
        duplicateMap.get(b.id)!.push(a.id);
      }
    }
  }

  return duplicateMap;
}

export function getDuplicateCount(serviceId: string, duplicateMap: Map<string, string[]>): number {
  return duplicateMap.get(serviceId)?.length || 0;
}
